import { render, staticRenderFns } from "./CardStudentName.vue?vue&type=template&id=1035a20f&scoped=true"
import script from "./CardStudentName.vue?vue&type=script&lang=js"
export * from "./CardStudentName.vue?vue&type=script&lang=js"
import style0 from "./CardStudentName.vue?vue&type=style&index=0&id=1035a20f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1035a20f",
  null
  
)

export default component.exports